import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function useSeo({ title, description, image }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:type", "website");
    if (image) {
      const abs = `${window.location.origin}${image}`;
      setMeta("property", "og:image", abs);
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", abs);
    }
  }, [title, description, image]);
}
